export const DEFAULT_MAPPED_QUESTIONS = {
    phone: "phone_number",
    party_support: "party_support",
    support_strength: "firmness",
};

export const DEFAULT_PARTY_STRENGTH = {
    Strong: 3,
    Moderate: 2,
    Weak: 1,
};

export const VOTER_STATUS_MASTER = [
    {
        key: "present",
        display: "Present",
        icon: "",
    },
    {
        key: "death",
        display: "Dead Voter",
        icon: "",
    },
    {
        key: "double_entry",
        display: "Double Entry",
        icon: "",
    },
    {
        key: "outside_voter",
        display: "Outside Voter",
        icon: "",
    },
    {
        key: "reset",
        display: "Reset",
        icon: "",
    },
    {
        key: "non_tracable",
        display: "Non Traceable",
        icon: "",
    },
];

export const CITY_MASTER = [
    { label: "Bangalore", value: "बेंगलोर" },
    { label: "Pune", value: "पुणे" },
    { label: "Mumbai", value: "मुंबई" },
    { label: "Ahmednagar", value: "अहमदनगर" },
    { label: "Nashik", value: "नाशिक" },
    { label: "Nagpur", value: "नागपूर" },
    { label: "Kolhapur", value: "कोल्हापूर" },
    { label: "Delhi", value: "दिल्ली" },
    { label: "Baramati", value: "बारामती" },
];
